<div class="video-player-container">
  @if (videoUrl) {
    <div class="video-wrapper">
      <video
        #videoElement
        [src]="videoUrl"
        (loadedmetadata)="onVideoLoaded($event)"
        (timeupdate)="onTimeUpdate()"
        (play)="onPlay()"
        (pause)="onPause()"
        (ended)="onPause()"
        class="video-element"
      >
        Your browser does not support the video tag.
      </video>

      <!-- Video Controls Overlay -->
      <div class="video-controls-overlay">
        <div class="controls-content">
          <button class="play-btn" (click)="togglePlay()">
            {{ isPlaying ? "⏸" : "▶" }}
          </button>
          <div class="progress-bar" (click)="seek($event)">
            <div class="progress-fill" [style.width.%]="progress"></div>
          </div>
          <span class="time-display">
            {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
          </span>
        </div>
      </div>
    </div>
  } @else {
    <div class="video-placeholder">
      <span>No video available</span>
    </div>
  }
</div>

